import "./MethodologyPage.css";
import MethodologyPDF from "@assets/files/Methodology.pdf";

/**
 * Methodology page component reproducing iscri_meth.html content
 * Displays methodology information and research papers
 */
const MethodologyPage = () => {
  return (
    <div className="methodology-page">
      {/* Hero Section */}
      <section className="hero-methodology">
        <div className="container hero-content">
          <h1 className="page-title">Methodology</h1>
        </div>
      </section>

      {/* Methodology Content Section */}
      <section className="methodology-content">
        <div className="container">
          <div className="creative-layout">
            <div className="content-block methodology-block reveal-element">
              <div className="icon-container">
                <div className="icon">📑</div>
              </div>
              <div className="block-content">
                <h2 className="block-title">ISCRI Methodology</h2>
                <p className="block-text">
                  <strong>The ISCRI indicator</strong> can be understood as the
                  cumulative outcomes of past interstate conflictual events: a
                  stock fed by flows of conflictual events.
                  <br />
                  For the full methodology, please see our methodology note.
                </p>
                <p className="block-text">
                  Working papers exploiting the ISCRI will be posted here soon.
                </p>
                <div className="document-actions">
                  <a
                    href={MethodologyPDF}
                    className="document-link primary-link"
                    download="ISCRI_Methodology.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📄 Download Methodology Note
                  </a>
                </div>
              </div>
            </div>

            {/* Data Sources Card */}
            <div className="content-block sources-block reveal-element">
              <div className="icon-container">
                <div className="icon">🗃️</div>
              </div>
              <div className="block-content">
                <h2 className="block-title">Data Sources</h2>
                <p className="block-text">
                  ISCRI is based on the automatic coding of media news recorded
                  in the
                  <strong>
                    {" "}
                    Global Data on Events, Location, and Tone (GDELT)
                  </strong>{" "}
                  database.
                </p>
                <div className="source-features">
                  <ul className="feature-list">
                    <li>Real-time media analysis</li>
                    <li>Global coverage since 1980</li>
                    <li>Automated event coding</li>
                    <li>Comprehensive source validation</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Technical Approach Card */}
            <div className="content-block technical-block reveal-element">
              <div className="icon-container">
                <div className="icon">⚙️</div>
              </div>
              <div className="block-content">
                <h2 className="block-title">Technical Approach</h2>
                <p className="block-text">
                  The ISCRI follows best practices in geopolitical risk
                  measurement and distinguishes between:
                </p>
                <div className="approach-types">
                  <div className="approach-item">
                    <h4 className="approach-title">💬 Verbal Conflicts</h4>
                    <p className="approach-desc">
                      Spoken criticism, threats, or accusations often related to
                      past or future potential acts of material conflict.
                    </p>
                  </div>
                  <div className="approach-item">
                    <h4 className="approach-title">⚔️ Material Conflicts</h4>
                    <p className="approach-desc">
                      Physical acts of conflictual nature including force
                      posture, coercion, assault, and mass violence.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact for Research Card */}
            <div className="content-block contact-research-block reveal-element">
              <div className="icon-container">
                <div className="icon">✉️</div>
              </div>
              <div className="block-content">
                <h2 className="block-title">Research Collaboration</h2>
                <p className="block-text">
                  Interested in collaborating or have questions about the
                  methodology? Contact our research team for more information.
                </p>
                <div className="contact-info">
                  <a
                    href="mailto:rodolphe.desbordes@skema.edu"
                    className="contact-email"
                  >
                    Contact Research Team
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MethodologyPage;
